import * as React from 'react';
import { StaticPageWrapper, IStaticPageWrapperProps, centeredMessageStyle } from 'components/static-pages/StaticPageWrapper';

export const CalmPage = (props:IStaticPageWrapperProps) => 
	<StaticPageWrapper backgroundImage="/res_sys/calm_splash.jpg" backgroundSize="cover" {...props}>
		<div style={centeredMessageStyle}>
			<div style={{textAlign:'center',fontFamily:'Open Sans',fontWeight:900,fontSize:'32px',color:'#263692', paddingTop:'20px', paddingBottom:'25px',lineHeight: '32px'}}>
				<img style={{width:'108px', height:'auto'}} src="/res_sys/calm_logo.png"/>
			</div>
			<div style={{fontSize:'18px',fontFamily:'Open Sans',fontWeight:300, fontStyle:'normal',color:'#263692', textAlign:'center',paddingBottom:'30px'}}>We recommend downloading Calm.</div>
			<div style={{textAlign:'center', marginTop:'0px', marginBottom:'25px'}}>
				<a target="_blank" href={'https://www.calm.com/'} aria-label={`GET THE APP, opens new tab`} className="go_button" style={{borderRadius:'40px',boxShadow: '2px 2px 4px 0px rgba(0,0,0,0.5)'}}>GET THE APP</a>
			</div>
			<div style={{fontSize:'18px',fontFamily:'Open Sans',fontWeight:600, fontStyle:'italic',color:'#4A4A4A', textAlign:'center',paddingBottom:'30px'}}>
			Relax Well, Sleep Well, Live Well<br/><br/>
			</div>
		</div>
	</StaticPageWrapper>
;

